import { render, staticRenderFns } from "./VoteOption.vue?vue&type=template&id=51c86b9e&scoped=true"
import script from "./VoteOption.vue?vue&type=script&lang=js"
export * from "./VoteOption.vue?vue&type=script&lang=js"
import style0 from "./VoteOption.vue?vue&type=style&index=0&id=51c86b9e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c86b9e",
  null
  
)

export default component.exports